module.exports = __webpack_public_path__ + "static/media/3DPPA4.ec6d96c4.jpg";